import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export async function getPartners(token: string): Promise<{
  partners: Partner[];
  selectedPartnerId: number | null;
}> {
  return await apiFetch(`${API_BASE}/api/management/partners`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function saveSelectedPartner(token: string, partner_id: number): Promise<{
  success: boolean;
}> {    
  return await apiFetch(`${API_BASE}/api/management/partners`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({partner_id: partner_id}),
  });
}

export interface Partner {
  id: number;
  title: string;
  image_url: string;
  detail: string;
  kindness: number;
  intelligence: number;
  cooperation: number;
  punctuality: number;
  originality: number;
  toughness: number;
  is_profile: boolean;
  created_at: string;

}